import * as React from "react";
const SvgFiRrSandwichAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sandwich-alt_svg__a)">
      <path
        fill="#062147"
        d="M.056 13.161a1 1 0 0 1 .616-1.273q.301-.106.555-.298c1.028-.782 2.52-.783 3.546 0a2.07 2.07 0 0 0 2.455 0c1.027-.783 2.518-.782 3.545 0a2.07 2.07 0 0 0 2.455 0c1.027-.783 2.518-.782 3.545 0a2.07 2.07 0 0 0 2.455 0c1.027-.783 2.518-.782 3.545 0q.255.194.556.299a1 1 0 0 1-.657 1.889 4 4 0 0 1-1.111-.597.97.97 0 0 0-1.122 0 4 4 0 0 1-2.438.82 4 4 0 0 1-2.439-.82.97.97 0 0 0-1.123 0c-1.407 1.072-3.469 1.073-4.877 0a.97.97 0 0 0-1.123 0c-1.407 1.072-3.469 1.073-4.877 0a.97.97 0 0 0-1.123 0c-.336.256-.71.457-1.11.596a1 1 0 0 1-1.273-.616M24 18.5v.5c0 2.206-1.794 4-4 4H4c-2.206 0-4-1.794-4-4v-.5C0 17.122 1.122 16 2.5 16h19c1.378 0 2.5 1.122 2.5 2.5m-2 0a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5v.5c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2zM24 6v.5C24 7.878 22.878 9 21.5 9h-19A2.503 2.503 0 0 1 0 6.5V6c0-2.206 1.794-4 4-4h16c2.206 0 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v.5a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sandwich-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSandwichAlt;
